import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdSupervisedUserCircle,
  MdPeople,
  MdAccountCircle,
  MdHome,
  MdSettings,
  MdEvent,
  MdEventNote
} from 'react-icons/md';

import Dashboard from 'pages/admin/home';
import Patients from 'pages/patients';
import UserProfile from 'pages/admin/profile';
import Users from 'pages/user';
import Settings from 'pages/admin/settings';
import Appointments from 'pages/appointment';
import AllVisits from 'pages/visits';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/home',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
    hidden: false,
  },
  {
    name: 'Patients',
    layout: '/admin',
    path: '/patients',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <Patients />,
    hidden: false,
  },
  // {
  //   name: 'Appointments',
  //   layout: '/admin',
  //   path: '/appointments',
  //   icon: <Icon as={MdEvent} width="20px" height="20px" color="inherit" />,
  //   component: <Appointments />,
  //   hidden: false,
  // },
  {
    name: 'Visits',
    layout: '/admin',
    path: '/visits',
    icon: <Icon as={MdEventNote} width="20px" height="20px" color="inherit" />,
    component: <AllVisits />,
    hidden: false,
  },
  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdSupervisedUserCircle} width="20px" height="20px" color="inherit" />,
    component: <Users />,
    hidden: false,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdAccountCircle} width="20px" height="20px" color="inherit" />,
    component: <UserProfile />,
    hidden: false,
  },
  {
    name: 'Settings',
    layout: '/admin',
    path: '/settings',
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: <Settings />,
    hidden: false,
  },
  
];

export default routes;
